import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { App } from '@capacitor/app';
import { IonicModule, Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { TranslateModule } from '@ngx-translate/core';

import { TransferSessionService } from '../../services/transfer-session/transfer-session.service';

@Component({
  selector: 'sc-migration',
  imports: [IonicModule, TranslateModule],
  templateUrl: './migration.component.html',
  styleUrl: './migration.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MigrationComponent {
  readonly transferSessionService = inject(TransferSessionService);

  private readonly platform = inject(Platform);
  private readonly storage = inject(Storage);

  readonly canBeClosed = signal<boolean>(true);
  readonly isLoggedIn = signal<boolean>(false);
  readonly isOpen = signal<boolean>(false);
  readonly isTargetAppInstalled = signal<boolean>(false);
  readonly isiOS = this.platform.is('ios');

  constructor() {
    this.handleDefaultState();

    if (Date.now() >= new Date('2027-01-01').getTime()) {
      this.canBeClosed.set(false);
      this.isOpen.set(true);
    }

    this.detectTargetApp();

    App.addListener('resume', () => {
      this.detectTargetApp();
    });
  }

  close() {
    this.isOpen.set(false);
    this.storage.set('migrationDismissed', true);
  }

  migrateSession() {
    this.transferSessionService.transferSessionRedirect();
  }

  private detectTargetApp() {
    this.transferSessionService.isTargetAppInstalled().then((result) => {
      this.isTargetAppInstalled.set(result.value);
    });
  }

  private async handleDefaultState() {
    if (!this.transferSessionService.canTransferFrom()) {
      return;
    }

    const dismissed = await this.storage.get('migrationDismissed');
    const loggedIn = await this.storage.get('token');

    this.isLoggedIn.set(!!loggedIn);

    if (!dismissed) {
      this.isOpen.set(true);
    }
  }
}
